__turbopack_context__.v({
  "container": "style-module__BkDtLq__container",
  "desktopOnly": "style-module__BkDtLq__desktopOnly",
  "freeShipping": "style-module__BkDtLq__freeShipping",
  "messageSeller": "style-module__BkDtLq__messageSeller",
  "secondaryCta": "style-module__BkDtLq__secondaryCta",
  "secondaryCtaGroup": "style-module__BkDtLq__secondaryCtaGroup",
  "sellerInactiveDisclaimer": "style-module__BkDtLq__sellerInactiveDisclaimer",
});
